import config from '../../config/config';

export const GA_ID = config.gaId;

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const pageView = (path: string): void => {
  if (!window.gtag) return;

  window.gtag('config', GA_ID, {
    page_path: path,
  });
};

export const trackEvent = (
  name: string,
  params: Record<string, any> = {}
): void => {
  if (!window.gtag) return;

  window.gtag('event', name, params);
};
